import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SkladPredmetu = {
	name: NAME,
	apiProvider,
	router,
};
